/**
 * Outils communs aux effets « waouh » (Cover3D, ScrollStage, OrbitVisualizer,
 * ParallaxHero). Aucune dépendance : lecture des préférences d'animation et
 * des couleurs du thème (variables CSS « R G B » posées sur <html>).
 */

export const clamp = (v: number, a = 0, b = 1) => (v < a ? a : v > b ? b : v)
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t
/** Courbe douce (ease-in-out cubique) sur [0,1]. */
export const ease = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)
/** Progression locale d'une phase [a,b] dans une progression globale p. */
export const seg = (p: number, a: number, b: number) => clamp((p - a) / (b - a))

/** Effets coupés : mode TV, « réduire les animations », ou coupure globale (fx-off). */
export function fxDisabled(): boolean {
  if (typeof window === 'undefined') return true
  const de = document.documentElement
  if (de.classList.contains('tv') || de.classList.contains('fx-off')) return true
  try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true } catch {}
  return false
}

/** Appareil modeste (peu de cœurs / de mémoire) → on allège ou on coupe. */
export function lowEndDevice(): boolean {
  if (typeof navigator === 'undefined') return true
  const n: any = navigator
  const cores = n.hardwareConcurrency || 4
  const mem = n.deviceMemory || 4
  return cores <= 3 || mem <= 2
}

/** Triplet « R G B » d'une variable CSS du thème → [r, g, b]. */
export function readTriplet(name: string, fallback: [number, number, number] = [124, 77, 255]): [number, number, number] {
  if (typeof window === 'undefined') return fallback
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  const parts = raw.split(/[\s,]+/).map(Number).filter(n => !Number.isNaN(n))
  return parts.length >= 3 ? [parts[0], parts[1], parts[2]] : fallback
}

/** Appelle `cb` quand le thème change (classe de <html>, ex. `light`). Renvoie le nettoyage. */
export function onThemeChange(cb: () => void): () => void {
  if (typeof MutationObserver === 'undefined') return () => {}
  const mo = new MutationObserver(cb)
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] })  // pas 'style' : --scroll y change à chaque défilement
  return () => mo.disconnect()
}
